// extracted by mini-css-extract-plugin
export default {"controls":"Matrix_controls__J4wRV","forbidden":"Matrix_forbidden__GxRAj"};